module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hj362"))).then(() => parcelRequire('hEqeo'));